import React from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import Home from '../components/website/home/Home.js';
import LandingPage from '../components/website/landing/LandingPage.js';
import SolutionsPage from '../components/website/landing/SolutionsPage.js';
import Shop from '../components/website/shop/Shop.js';
import Cart from '../components/website/cart/Cart.js';
import Product from '../components/website/product/Product.js';
import RegistrationForm from '../components/website/account/signup/RegistrationForm.js'
import LoginForm from '../components/website/account/signin/LoginForm.js'
import ForgotPassword from '../components/website/account/signin/ForgotPassword.js'
import ResetPassword from '../components/website/account/signin/ResetPassword.js'
import CheckoutForm from '../components/website/checkout/CheckoutForm.js';
import PickupLocation from '../components/website/pickup-location/PickupLocation.js';
import Profile from '../components/website/account/Profile.js';
import AccountDashboard from '../components/website/account/AccountDashboard.js';
import OrderConfirmation from '../components/website/checkout/OrderConfirmation.js';
import SubscriptionSelection from '../components/website/subscription/SubscriptionSelection.js';
import PrivateRoute from './PrivateRoute';
import Producers from '../components/website/Producers.js';
// import AdminLogin from '../components/admin/login/AdminLogin.js';

// Apex domains serve the B2B marketing landing site; `home.*` subdomains serve
// the customer storefront (shop / login). Legacy farmetohome.com and
// farmersmarketspace.com both follow this pattern. Localhost stays on the
// storefront unless `?landing=1` is used to preview the landing page.
const LANDING_APEX_HOSTS = new Set([
    'farmersmarketspace.com',
    'www.farmersmarketspace.com',
    'farmetohome.com',
    'www.farmetohome.com',
]);

const isLandingSite = () => {
    if (typeof window === 'undefined') return false;
    const host = window.location.hostname;
    if (LANDING_APEX_HOSTS.has(host)) return true;
    if (host === 'localhost' && window.location.search.includes('landing=1')) return true;
    return false;
};

const HandleRoute = () => {
    return (
        <Routes>
            <Route path="/" element={isLandingSite() ? <LandingPage /> : <Home />} />
            <Route path="/solutions" element={isLandingSite() ? <SolutionsPage /> : <Navigate to="/" replace />} />
            <Route path="/account/signin" element={<LoginForm />} />
            <Route path="/account/forgot-password" element={<ForgotPassword />} />
            <Route path="/account/reset-password" element={<ResetPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/account/signup" element={<RegistrationForm />} />
            <Route path="/shop" element={<Shop />} />
            <Route path="/cart/:id" element={<Cart />} />
            <Route path="/cart" element={<Cart />} />
            <Route path="/product/:id" element={<Product />} />
            {/* <Route path="/checkout" element={<PrivateRoute><CheckoutForm /></PrivateRoute>} /> */}
            <Route path="/pickup-location" element={<PickupLocation />} />
            <Route path="/account/profile" element={<PrivateRoute><Profile /></PrivateRoute>} />
            <Route path="/account/dashboard" element={<PrivateRoute><AccountDashboard /></PrivateRoute>} />
            <Route path="/order-confirmation" element={<OrderConfirmation />} />
            <Route path="/producers" element={<Producers />} />
            <Route path="/membership" element={<SubscriptionSelection />} />
            <Route path="/subscription/select" element={<PrivateRoute><SubscriptionSelection /></PrivateRoute>} />
        </Routes>
    );
}

export default HandleRoute;